// extracted by mini-css-extract-plugin
module.exports = {"loginButton":"LoginButton_loginButton__9EKmo","buttonText":"LoginButton_buttonText__uhCKL"};